export default {"src":"/_next/static/media/ContactUsPhoneIcon.2c27552e.svg","height":43,"width":42,"blurWidth":0,"blurHeight":0};